// 定义主页路由
export const HOME_ROUTE = {
	name: 'home',
	path: '/home',
	params: {},
	query: {},
	meta: {
		title: 'home',
		icon: 'icon-home'
	}
};

// 关于cookie的设置
export const COOKIES_EXPIRES = 1; // 以天为单位
export const COOKIE_KEY_TOKEN = 'token';

// token的即将过期时间
export const TOKEN_TIMEOUT = 15 * 60 * 1000;

// localStorage删除名单 用于登录失败，清除需要清除的localStorage
export const STORAGE_LIST_BY_LOGIN = ['token', 'expires_time'];

// 路由跳转白名单
export const ROUTES_WHITE_LIST = [
	'authorize',
	'buffer',
	'logout',
	'login',
	'doc',
	'error-401',
	'error-404',
	'error-500',
	'usage-desc',
	'usage-details',
	'dangerous-add',
	'dangerous-edit',
	'black-import',
	'dorm-management',
	'dorm-record',
	'dorm-rules',
	'dorm-manage',
	'dorm-summary',
	'dorm-import',
	'dorm-setting',
	'dorm-boarder-edit',
	'dorm-detail',
	'dorm-edit',
	'dorm-ruleSet',
	'application-creating',
	'news-addNews',
	'news-edit',
	'health-management',
	'epidemic-report',
	'heatlth-day',
	'distribution-withdraw',
	'entrance-guard-rules-edit',
	'school-export',
	'custom-tag',
	'label-management',
	'label-details',
	'add-members',
	'batch-Import',
	'batch-face-entry',
	'historical-details',
	'result-add-edit',
	'result-collect',
	'result-detail',
	'result-import',
	'service-management-new',
	'face-entry-abnormal',
	'face-recognition-camera',
	'package-content',
	'modify-ordering',
	'bulk-ordering',
	'no-meals',
	'face-charging-system',
	'notice-template-edit',
	'info-student-manage',
	'student-manage',
	'student-import-export',
	'addCamera',
	'face-payment',
	'statistical-report',
	'face-payment-user-info',
	'face-payment-device-manage',
	'pushFlowTest',
	'videoParameters',
	'createCharge',
	'chargeDetails',
	'batch-application',
	'brand-configuration-config',
	'questionnaire-details',
	'personal-evaluation',
	'batch-open',
	'createCode',
	'codeDetail',
	'card-management'
];

// 缓存忽略
export const KEEP_ALIVE_EXCLUDE_LIST = ['news-edit', 'news-addNews'];

// 身份免验证白名单
export const ROLES_WHITE_LIST = ['admin'];

// 学校角色列表
export const SCHOOL_ROLES_LIST = [
	'学校', // 即学校管理员
	'学校职工',
	'商户'
];

// 代理商角色列表
export const AGENT_ROLES_LIST = ['代理商'];

// 系统人员角色列表
export const SYSTEM_ROLES_LIST = ['运营人员', '系统管理员'];

// table样式
export const TABLE_STYLE = {
	head:
		'background: #f9f9f9;font-size: 14px;color: #333333;font-weight: 500;height: 53px',
	head_column1:
		'background: #f9f9f9;font-size: 14px;color: #333333;font-weight: 500',
	first: 'background-color: #f9f9f9; color: #ff8037;'
};
